module.exports = __webpack_public_path__ + "img/kui_AAAI.ec24203e.png";